import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import { FixtureState } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { LabelL, LabelM } from '@sorare/core/src/atoms/typography';
import { FixtureStatus } from '@sorare/core/src/components/lobby/FixtureStatus';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import {
  FOOTBALL_PLAY_RIVALS_LEAGUES,
  FOOTBALL_PLAY_RIVALS_LEAGUES_LEADERBOARD,
  FOOTBALL_PLAY_RIVALS_LEAGUES_LEADERBOARD_PRIZE_POOL,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';

const EURO_END_DATE = new Date('2024-07-15');

const LeaguesLeaderboardLayout = () => {
  return (
    <>
      <PageHeader
        backTo={FOOTBALL_PLAY_RIVALS_LEAGUES}
        customTitle={
          <Vertical gap={0}>
            <LabelL bold>
              <FormattedMessage {...glossary.rewards} />
            </LabelL>
            <LabelM color="var(--c-neutral-600)">
              <FormattedMessage {...glossary.europeanChampionship} />
            </LabelM>
          </Vertical>
        }
      />
      <Portal id="page-header-right-button">
        <FixtureStatus
          fixtureState={FixtureState.opened}
          startDate={EURO_END_DATE}
        />
      </Portal>
      <ContentWithStickyHeader
        header={
          <TabBar fullWidth variant="flat">
            <Tab
              to={FOOTBALL_PLAY_RIVALS_LEAGUES_LEADERBOARD}
              matches={[FOOTBALL_PLAY_RIVALS_LEAGUES_LEADERBOARD]}
            >
              <FormattedMessage {...glossary.leaderboards} />
            </Tab>
            <Tab
              to={FOOTBALL_PLAY_RIVALS_LEAGUES_LEADERBOARD_PRIZE_POOL}
              matches={[FOOTBALL_PLAY_RIVALS_LEAGUES_LEADERBOARD_PRIZE_POOL]}
            >
              <FormattedMessage
                id="LeaguesLeaderboardLayout.prizePools"
                defaultMessage="Prize Pool"
              />
            </Tab>
          </TabBar>
        }
      >
        <Outlet />
      </ContentWithStickyHeader>
    </>
  );
};
export default LeaguesLeaderboardLayout;
